var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F47822;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_529_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,285.9H40.3v133.9h276.3L365.6,285.9z M130.5,380.4h-9.2V357H96.8v23.5h-9.2v-55h9.2   v24.2h24.6v-24.2h9.2V380.4z M181.7,332.8h-17v47.6h-9.2v-47.6h-16.7v-7.4h42.9V332.8z M246.7,380.4h-9.2v-39.5l-0.2,0l-15.1,39.6   h-6.3l-15.4-40.3l-0.2,0.1v40.2H191v-55h12.1l15.8,42.3h0.2l15.9-42.3h11.7V380.4z M295.6,380.4h-34.9v-55h9.2v47.7h25.8V380.4z",
    id: "XMLID_533_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.9,6L352.9,6L107.4,6c-7.3,0-13.3,6-13.3,13.3v256.8h26.6V32.6h232.2v92.2h92.2v354.6   H120.7v-49.8H94.1v63.1c0,7.3,6,13.3,13.3,13.3h351c7.3,0,13.3-6,13.3-13.3V124.8L352.9,6z",
    id: "XMLID_532_"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 19.6,
    id: "XMLID_531_",
    width: 253.4,
    x: 156.2,
    y: 171.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 19.6,
    id: "XMLID_530_",
    width: 213.3,
    x: 156.2,
    y: 209.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.7ed899f7b6799d443655b3883842651a.svg";
export { ForwardRef as ReactComponent };